import { v4 as uuidv4 } from 'uuid';
import EntityStore, { BaseEntity, PublicEntityStore } from './entity';

export default class PublicStore<Entity extends BaseEntity>
  implements PublicEntityStore<Entity>
{
  public id: string = uuidv4();
  private store: EntityStore<Entity>;
  constructor(store: EntityStore<Entity>) {
    this.store = store;
  }

  /* Returns the public store read-only methods */
  public selectById: PublicEntityStore<Entity>['selectById'] = (...args) =>
    this.store.selectById(...args);
  public item: PublicEntityStore<Entity>['item'] = (...args) =>
    this.store.item(...args);
  public list: PublicEntityStore<Entity>['list'] = (...args) =>
    this.store.list(...args);
  public listIds: PublicEntityStore<Entity>['listIds'] = (...args) =>
    this.store.listIds(...args);
}
